import {color_transparent} from "../../../../constants/colors";

export const styles = {
    modalContainer: {
        backgroundColor: color_transparent,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 15,
        overflow: "hidden",
    }
}